export default __webpack_public_path__ + "static/media/Pride.4d2d33a8.png";